<template>
  <div class="hayaban_osoban">
    <h3>早番・遅番申請</h3>
    <template v-if="data">
      <div class="flex">
        <b class="title">申請日</b>
        <p>{{ data.shinsei_date }}</p>
      </div>

      <div class="flex">
        <b class="title">就業場所</b>
        <p>{{ data.syuugyou_basyo_name }}</p>
      </div>

      <div class="flex">
        <b class="title">社員番号</b>
        <p>{{ data.staff_code }}</p>
      </div>

      <div class="flex">
        <b class="title">氏名</b>
        <p>{{ data.staff_name }}</p>
      </div>

      <div class="flex">
        <b class="title">勤務日</b>
        <p>{{ data.target_dakoku_date }}</p>
      </div>

      <div class="flex">
        <b class="title">開始日時</b>
        <div class="table-item">
          <p>{{ data.start_datetime }}</p>
        </div>
      </div>

      <div class="flex">
        <b class="title">終了日時</b>
        <div class="table-item">
          <p>{{ data.end_datetime }}</p>
        </div>
      </div>

      <div class="flex">
        <b class="title">休憩時間</b>
        <p>{{ data.kyuukei_times }}</p>
      </div>
    </template>
  </div>
</template>

<script lang="ts">

import { Ref, defineComponent, onMounted, ref } from 'vue';
import { HayabanOsobanDetail } from '@/types/Shinsei';
import { HayabanOsobanService } from '@/service/HayabanOsobanService';

export default defineComponent({
  props: {
    id: {
      type: Number,
      require: true,
      default: null
    }
  },
  setup(props) {
    const data: Ref<HayabanOsobanDetail | null> = ref(null)
    const srv = new HayabanOsobanService()
    onMounted(async () => {
      if(!props.id) {
        return
      }

      data.value = await srv.getDetail(props.id)
    })
    return {
      data
    }
  }
})

</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>